import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import "./_index.scss"
import { currencyShotern, decryptedValue } from "common/utility";
import { useParams, useNavigate } from "react-router-dom";
import { downloadEntityInfo, getEntityDetails } from "http/fundLync/entityAndAddress.helper";
import ToastDialog from "components/Common/ToastDialog";
import { isEmpty } from "lodash";
import API_SERVICES from "constants/app.constants";
import { formatStringToDisplay, formatStringWithToUpperCase } from "../../common/helper";
import moment from "moment";
import NoDataChart from "./NoDataChart";
import ShowMoreComponent from "./ShowMoreComponent";
import BackButton from "components/Common/BackButton";

const EntityInformation = () => {

    document.title = "Entity Information | Fundlync";

    const summaryOptions = {
        chart: {
            toolbar: "false",
            zoom: {
                enabled: false,
            },
            dropShadow: {
                enabled: false,
                color: "#000",
                top: 18,
                left: 7,
                blur: 8,
                opacity: 0.2,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 3,
                columnWidth: '40%'
            }
        },
        xaxis: {
            categories: [],
            labels: {
                show: true,
                rotateAlways: false,
                style: {
                    fontSize: "10px",
                },
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return val
                },
            },
        },
        dataLabels: {
            enabled: !1,
        },
        colors: [],
        stroke: {
            curve: "smooth",
            width: 1,
        },
    };

    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [entityInformation, setEntityInformation] = useState({});
    const [summaryIndex, setSummaryIndex] = useState(0);

    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const entityId = urlParams.get("id");
    const entityName = urlParams.get("entityName");
    const userData = decryptedValue(localStorage.getItem("user")) || {};
    const userObj = userData;
    const decodedId = entityId ? atob(entityId) : userObj.entityId;

     const formatNumberWithCommasinfo = (number) => {
        if(!number || number == 0||isNaN(Number(number))) {
          return '-';
        } else {
          const formattedNumber = Number(number).toFixed(2).toString().replace(/\./, ',');
          const parts = formattedNumber.split(',');
          if (parts[0].length > 3) {
            const lastThree = parts[0].substr(parts[0].length - 3);
            const remaining = parts[0].slice(0, parts[0].length - 3);
            parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
          }
          let formattedPrice =  ' ' + parts.join('.');
          return formattedPrice;
        }
      };


    useEffect(() => {
        getEntityInformation()
    }, [])


    const getEntityInformation = async () => {
        const bodyData = {
            entityId: decodedId
        }
        const entityInfo = await getEntityDetails(bodyData);
        if (entityInfo.status) {
            setEntityInformation(entityInfo.data)
        } else {
            setToastInfo({ message: entityInfo.message, showToast: true, role: "error" });
        }
    }

    const handleMoreInfo = () => {
        navigate(`/${userObj.roleName}/entity/more-info?id=${entityId}&entityName=${entityName}`)
    }

    let entityBasicInfo = !isEmpty(entityInformation) ? {
        'name': (!isEmpty(entityInformation)) ? entityInformation?.entity_name : '',
        'PAN': (!isEmpty(entityInformation)) ? entityInformation?.pan : '',
        'GSTIN': (!isEmpty(entityInformation)) ? entityInformation?.gstn_in : '',
        'CIN': (!isEmpty(entityInformation)) ? entityInformation?.cin : '',
        'others': [{ "label": "Listed", "value": "-" }],
    } : {}

    let authPersons = entityInformation?.authorisedPeople ? entityInformation.authorisedPeople.map(item => {
        return {
            name: item.firstName + ' ' + item.lastName,
            doj: item.date_of_appointment,
            designation: !isEmpty(item.type) ? formatStringWithToUpperCase(item.type) : '',
        }
    }) : []

    let entitySummary = [
        {
            "name": "Net Worth",
            "color": "#34c38f",
            "data": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.networth)) ? entityInformation.scoreMeResponse.networth.map(item => {
                return {
                    xAxis: item.year,
                    yAxis: item.unit == 'lakhs' ? `${Number(item.value).toFixed(2)} L` : item.value
                }
            }) : [],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.networth) ? entityInformation.scoreMeResponse.networth[0].unit : '',
            "value": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.networth)) ? entityInformation.scoreMeResponse.networth[entityInformation.scoreMeResponse.networth.length - 1].value : 0,
        }, {

            "name": "PAT",
            "color": "#34c38f",
            "data": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.pat)) ? entityInformation.scoreMeResponse.pat.map(item => {
                return {
                    xAxis: item.year,
                    yAxis: item.unit == 'lakhs' ? `${Number(item.value).toFixed(2)} L` : item.value
                }
            }) : [],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.pat) ? entityInformation.scoreMeResponse.pat[0].unit : '',
            "value": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.pat)) ? entityInformation.scoreMeResponse.pat[entityInformation.scoreMeResponse.pat.length - 1].value : 0,
        },
        {
            "name": "EBITDA",
            "color": "#34c38f",
            "data": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.ebitda)) ? entityInformation.scoreMeResponse.ebitda.map(item => {
                return {
                    xAxis: item.year,
                    yAxis: item.unit == 'lakhs' ? `${Number(item.value).toFixed(2)} L` : item.value
                }
            }) : [],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.ebitda) ? entityInformation.scoreMeResponse.ebitda[0].unit : '',
            "value": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.ebitda)) ? entityInformation.scoreMeResponse.ebitda[entityInformation.scoreMeResponse.ebitda.length - 1].value : 0,
        },
        {
            "name": "Revenue",
            "color": "#34c38f",
            "data": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.revenue)) ? entityInformation.scoreMeResponse.revenue.map(item => {
                return {
                    xAxis: item.year,
                    yAxis: item.unit == 'lakhs' ? `${Number(item.value).toFixed(2)} L` : item.value
                }
            }) : [],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.revenue) ? entityInformation.scoreMeResponse.revenue[0].unit : '',
            "value": (!isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.revenue)) ? entityInformation.scoreMeResponse.revenue[entityInformation.scoreMeResponse.revenue.length - 1].value : 0,
        },


    ]


    const initSummaryChartData = () => {
        const unit = entitySummary[summaryIndex].unit
        const xAxisLabel = !isEmpty(entitySummary[summaryIndex].data) ? entitySummary[summaryIndex].data.map((obj) => obj.xAxis) : []
        const yAxisValues = !isEmpty(entitySummary[summaryIndex].data) ? entitySummary[summaryIndex].data.map((obj) => obj.yAxis) : []

        const options = summaryOptions
        options.xaxis.categories = xAxisLabel
        options.yaxis.labels.formatter = (!isEmpty(yAxisValues) && yAxisValues[0].includes('L')) ? (val) => {
            if (unit == 'lakhs') {
                return `₹ ${formatNumberWithCommasinfo((val).toFixed(2))} L`
            } else {
                return formatNumberWithCommasinfo(currencyShotern(val))
            }
        } : (val) => {
            return formatNumberWithCommasinfo(val)
        }

        const series = [
            {

                data: [...yAxisValues],
                color: entitySummary.color,
            },
        ]
        return { series, options }
    }

    const initBarChartData = (chartData) => {
        let unit = chartData['unit']

        const category = chartData.category
        const data = chartData.data
        const xAxisLabel = data.map((obj) => obj.xAxis);

        const series = []

        category.forEach(cat => {
            const yAxisValues = data.map((obj) => obj.yAxis[cat.key])
            series.push({
                name: cat.name,
                data: [...yAxisValues],
                color: cat.color
            })

        });

        const options = JSON.parse(JSON.stringify(summaryOptions))
        options.xaxis.categories = xAxisLabel
        if (chartData.yValueType == 'amount') {
            options.yaxis.labels.formatter = (val) => {
                if (unit == 'lakhs') {
                    return `₹ ${formatNumberWithCommasinfo((val).toFixed(2))} L`
                } else {
                    return formatNumberWithCommasinfo(currencyShotern(val))
                }
            }
        } else if (chartData.yValueType == 'percentage')

            options.yaxis.labels.formatter = (val) => {
                return `${val}%`
            }
        else {
            options.yaxis.labels.formatter = (val) => {
                return val
            }
        }


        return { series, options }
    }

    const initPieChartData = (chartData) => {
        let unit = chartData['unit']
        const labels = (!isEmpty(chartData) && !isEmpty(chartData.data)) ? chartData.data.map((obj) => obj.label) : [];
        const series = (!isEmpty(chartData) && !isEmpty(chartData.data)) ? chartData.data.map((obj) => Number(obj.value)) : [];

        const options = JSON.parse(JSON.stringify(summaryOptions))
        options.labels = labels;
        options.dataLabels = {
            enabled: true
        };

        options.tooltip = {
            enabled: true,
            y: {}

        }

        if (chartData.valueType == 'amount') {
            options.tooltip.y.formatter = (val) => {
                if (unit == 'thousands') {
                     return `₹ ${formatNumberWithCommasinfo((val).toFixed(2))} K`
                } else if (unit == 'lakhs') {
                     return `₹ ${formatNumberWithCommasinfo((val).toFixed(2))} L`
                } else if (unit == 'crores') {
                   return `₹ ${formatNumberWithCommasinfo((val).toFixed(2))} Cr`
                } else {
                    return formatNumberWithCommasinfo(currencyShotern('₹' + val))
                }
            }
        } else if (chartData.valueType == 'percentage')
            options.tooltip.y.formatter = (val) => {
                return `${val}%`
            }
        else {
            options.tooltip.y.formatter = (val) => {
                return val
            }
        }
        options.legend = {
            position: 'bottom'
        }
        return { series, options }

    }

    let summaryChartData = {
        series: initSummaryChartData().series,
        options: initSummaryChartData().options,
    }


    let financialIncomeInfo = [
        {
            "id": "income",
            "name": "Income Statement Movement",
            "chartType": "bar",
            "yValueType": "amount",
            "category": [
                { "name": "Revenue", "key": "revenue", "color": "#4d6d9b" },
                { "name": "EBITDA", "key": "ebitda", "color": "#8cb9fc" }
            ],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.revenue) ? entityInformation.scoreMeResponse.revenue[0].unit : '',
            "data": (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.revenue)) ? entityInformation.scoreMeResponse.revenue.map(item => {
                let totalRevenue = item.value
                let totalEbitdaResponse = (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.ebitda)) ? entityInformation.scoreMeResponse.ebitda : []
                let totalEbitdaFilter = totalEbitdaResponse.filter(item2 => item2.year == item.year).reduce((a, b) => Number(a.value) + Number(b.value))
                let totalEbitda = totalEbitdaFilter?.value ?? 0
                return {
                    xAxis: item.year,
                    yAxis: { "revenue": totalRevenue, "ebitda": totalEbitda }
                }
            }) : []
        },
        {
            "id": "balance",
            "name": "Balance Sheet Movement",
            "chartType": "bar",
            "yValueType": "amount",
            "category": [
                { "name": "Networth", "key": "networth", "color": "#f39382" },
                { "name": "Debt", "key": "debt", "color": "#9badc7" }
            ],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.networth) ? entityInformation.scoreMeResponse.networth[0].unit : '',
            "data": (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.debt)) ? entityInformation.scoreMeResponse.debt.map(item => {
                let totalDebt = item.value
                let totalNetResponse = (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.debt)) ? entityInformation.scoreMeResponse.networth : []

                let totalNetworthFilter = totalNetResponse.filter(item2 => item2.year == item.year).reduce((a, b) => Number(a.value) + Number(b.value))
                let totalNetworth = totalNetworthFilter?.value ?? 0

                return {
                    xAxis: item.year,
                    yAxis: { "networth": totalNetworth, "debt": totalDebt }
                }
            }) : []
        },
        {
            "id": "leverage",
            "name": "Leverage Ratio",
            "chartType": "line",
            "yValueType": "number",
            "category": [
                { "name": "Debt/Networth", "key": "networth", "color": "#f39382" },
                { "name": "Debt/EBITDA", "key": "debt", "color": "#9badc7" }
            ],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.networth) ? entityInformation.scoreMeResponse.networth[0].unit : '',
            "data": !isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.debt) ? entityInformation.scoreMeResponse.debt.map(item => {
                let totalDebt = item.value
                let totalNetResponse = (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.debt)) ? entityInformation.scoreMeResponse.networth : []
                let totalNetworthFilter = totalNetResponse.filter(item2 => item2.year == item.year).reduce((a, b) => Number(a.value) + Number(b.value))
                let totalNetworth = totalNetworthFilter?.value ?? 0;

                let networthData = Number((totalDebt / totalNetworth).toFixed(3))

                let totalEbitdaResponse = (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.ebitda)) ? entityInformation.scoreMeResponse.ebitda : []
                let totalEbitdaFilter = totalEbitdaResponse.filter(item2 => item2.year == item.year).reduce((a, b) => Number(a.value) + Number(b.value))
                let totalEbitda = totalEbitdaFilter?.value ?? 0;

                let totalEbitdaData = Number((totalDebt / totalEbitda).toFixed(3))
                return {
                    xAxis: item.year,
                    yAxis: { "networth": networthData, "debt": totalEbitdaData }
                }
            }) : []
        },
        {
            "id": "margin",
            "name": "EBITDA and Pat Margin",
            "chartType": "line",
            "yValueType": "percentage",
            "category": [
                { "name": "EBITDA", "key": "ebitda", "color": "#f39382" },
                { "name": "PAT", "key": "pat", "color": "#9badc7" }
            ],
            "unit": !isEmpty(entityInformation?.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.networth) ? entityInformation.scoreMeResponse.networth[0].unit : '',
            "data": !isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.pat) ? entityInformation.scoreMeResponse.pat.map(item => {
                let totalPat = item.value
                let totalEbitdaResponse = (!isEmpty(entityInformation) && !isEmpty(entityInformation.scoreMeResponse) && !isEmpty(entityInformation.scoreMeResponse.ebitda)) ? entityInformation.scoreMeResponse.ebitda : []

                let totalEbitdaFilter = totalEbitdaResponse.filter(item2 => item2.year == item.year).reduce((a, b) => Number(a.value) + Number(b.value))
                let totalEbitda = totalEbitdaFilter?.value ?? 0;
                return {
                    xAxis: item.year,
                    yAxis: { "ebitda": totalEbitda, "pat": totalPat }
                }
            }) : []
        }
    ]

    const financialIncomeChartData = {}


    financialIncomeInfo.forEach(obj => {
        const incomeChartResult = initBarChartData(obj)
        financialIncomeChartData[obj.id] = incomeChartResult
    });

    let bProfileData = []
    let borrowingProfilesData = (!isEmpty(entityInformation) && !isEmpty(entityInformation.borrowingProfiles)) ? entityInformation.borrowingProfiles.lenderList : []

    if (!isEmpty(borrowingProfilesData) && borrowingProfilesData[0].type == '') {
        borrowingProfilesData = []
    }

    let borrowing = borrowingProfilesData
    borrowing = borrowing.sort((a, b) => (Number(b.sanctionedAmount) - Number(a.sanctionedAmount)))
    if (!isEmpty(borrowing)) {
        let item = { label: formatStringToDisplay(borrowing[0].type, '_'), value: (borrowing[0].sanctionedAmount) };
        bProfileData = [...bProfileData, item];
    }
    if (!isEmpty(borrowing) && borrowing.length > 1) {
        let item = { label: formatStringToDisplay(borrowing[1].type, '_'), value: (borrowing[1].sanctionedAmount) };
        bProfileData = [...bProfileData, item];
    }
    if (!isEmpty(borrowing) && borrowing.length > 2) {
        let dataSType = bProfileData.map(item => item.label)

        let tempItemArr = borrowing.filter(item => !dataSType.includes(formatStringToDisplay(item.type, '_')));

        if (!isEmpty(tempItemArr) && tempItemArr.length == 1) {
            let item = { label: formatStringToDisplay(tempItemArr[0].type, '_'), value: (tempItemArr[0].sanctionedAmount) };
            bProfileData = [...bProfileData, item];
        } else {
            let sanctionedAmount = !isEmpty(tempItemArr) ? tempItemArr.map(item => item.sanctionedAmount).reduce((a, b) => Number(a) + Number(b)) : 0
            let itemObj = { label: 'Others', value: sanctionedAmount }
            bProfileData = [...bProfileData, itemObj]
        }
    }

    let borrowingProfileUnit = !isEmpty(entityInformation) && !isEmpty(entityInformation.borrowingProfiles) ? entityInformation.borrowingProfiles.unitValue : ''
    let borrowingProfileData = {
        "valueType": "amount",
        "data": bProfileData,
        "unit": borrowingProfileUnit
    }

    let borrowingChartData = {
        series: initPieChartData(borrowingProfileData).series,
        options: initPieChartData(borrowingProfileData).options,
    }



    let sProfileData = []
    let shareHoldingProfiles = (!isEmpty(entityInformation) && !isEmpty(entityInformation.shareholdingPatterns.shareholderList)) ? entityInformation.shareholdingPatterns.shareholderList : []


    let shareholding = shareHoldingProfiles
    shareholding = shareholding.sort((a, b) => (Number(b.percentageHolding) - Number(a.percentageHolding)))
    shareholding = shareholding.filter(item => item.percentageHolding > 0)

    if (!isEmpty(shareholding)) {
        let item = { label: formatStringToDisplay(shareholding[0].shareholderType, '_'), value: shareholding[0].percentageHolding };
        sProfileData = [...sProfileData, item];
    }
    if (!isEmpty(shareholding) && shareholding.length > 1) {
        let item = { label: formatStringToDisplay(shareholding[1].shareholderType, "_"), value: shareholding[1].percentageHolding };
        sProfileData = [...sProfileData, item];
    }
    if (!isEmpty(shareholding) && shareholding.length > 2) {
        let dataSType = sProfileData.map(item => item.label)
        let tempItemArr = shareholding.filter(item => !dataSType.includes(formatStringToDisplay(item.shareholderType, '_')));

        if (!isEmpty(tempItemArr) && tempItemArr.length == 1) {
            let item = { label: formatStringToDisplay(tempItemArr[0].shareholderType, '_'), value: tempItemArr[0].percentageHolding };
            sProfileData = [...sProfileData, item];

        } else {
            let shareHolderValue = !isEmpty(tempItemArr) ? tempItemArr.map(item => item.percentageHolding).reduce((a, b) => Number(a) + Number(b)) : 0
            let itemObj = { label: 'Others', value: shareHolderValue }
            sProfileData = [...sProfileData, itemObj]
        }
    }




    let shareHoldingData = {
        "valueType": "percentage",
        "data": sProfileData
    }

    let shareholdingChartData = {
        series: initPieChartData(shareHoldingData).series,
        options: initPieChartData(shareHoldingData).options,
    }

    let shareHoldingPattersChartDate = ''

    if (!isEmpty(entityInformation) && !isEmpty(entityInformation.shareholdingPatterns.shareHoldingAsOf)) {
        let shareHoldingAsOf = entityInformation.shareholdingPatterns.shareHoldingAsOf
        shareHoldingPattersChartDate = !isEmpty(shareHoldingAsOf) ? moment(shareHoldingAsOf).format('MMM DD, YYYY') : ''
    }

    let borrowingProfileChartDate = ''

    if (!isEmpty(entityInformation) && !isEmpty(entityInformation.borrowingProfiles.borrowingAsOf)) {
        let borrowingAsOf = entityInformation.borrowingProfiles.borrowingAsOf
        borrowingProfileChartDate = !isEmpty(borrowingAsOf) ? moment(borrowingAsOf).format('MMM DD, YYYY') : ''
    }


    return (
        <React.Fragment>
            <div className={entityName ? "page-content" : ""}>
                <Container fluid>
                    {/* <BackButton /> */}
                    {entityName ? <BackButton /> : null}
                    <div className={entityName ? "vertical-scroll" : ""}>
                        {
                            <div className="d-flex flex-column">
                                {entityName ? (
                                 <Row >
                                    <Col className="col-12 mt-3 mb-3">
                                        <h3>{!isEmpty(entityBasicInfo.name) ? entityBasicInfo.name : ''}</h3>
                                    </Col>
                                    <Col md="3">
                                        <div className="d-flex flex-column">
                                            <span>PAN</span>
                                            <span>{!isEmpty(entityBasicInfo.PAN) ? entityBasicInfo.PAN : API_SERVICES.EMPTY_VALUE}</span>
                                        </div>
                                    </Col>
                                    <Col md="3">
                                        <div className="d-flex flex-column">
                                            <span>GSTIN</span>
                                            <span>{!isEmpty(entityBasicInfo.GSTIN) ? entityBasicInfo.GSTIN : API_SERVICES.EMPTY_VALUE}</span>
                                        </div>
                                    </Col>
                                    <Col md="3">
                                        <div className="d-flex flex-column">
                                            <span>CIN</span>
                                            <span>{!isEmpty(entityBasicInfo.CIN) ? entityBasicInfo.CIN : API_SERVICES.EMPTY_VALUE}</span>
                                        </div>
                                    </Col>
                                    {!isEmpty(entityBasicInfo.others) && entityBasicInfo.others.map((r) => {
                                        return (
                                            <Col md="3" key={r.label}>
                                                <div className="d-flex flex-column label-txt">
                                                    <span className="label">{r.label}</span>
                                                    <span className="label-value">{r.value}</span>
                                                </div>
                                            </Col>
                                        )
                                    })}

                                </Row>
                                ):(null) }
                                
                                <Row className="mt-5">
                                    <Col md="12">
                                        <Card>
                                            <CardBody>
                                                <Row>
                                                    <Col className="col-12">
                                                        <h5>Summary</h5>
                                                    </Col>
                                                    <Col md="9">
                                                        {summaryChartData &&
                                                            <ReactApexChart
                                                                series={summaryChartData.series}
                                                                options={summaryChartData.options}
                                                                type="line"
                                                                height={320}
                                                                className="apex-charts"
                                                            />
                                                        }
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="d-flex flex-column">
                                                            {entitySummary.map((sum, index) => {
                                                                return (
                                                                    <div className="d-flex" key={sum.name} >
                                                                        <div className={`triangle-left ${index == summaryIndex ? 'selected' : ''}`}></div>
                                                                        <div role="button" className={`summary-tab ${index == summaryIndex ? 'selected' : ''}`} onClick={() => setSummaryIndex(index)}>
                                                                            <span className={`light ${index == summaryIndex ? 'selected' : ''}`}>{(sum.unit == 'lakhs') ? `₹ ${formatNumberWithCommasinfo(((sum.value)).toFixed(2))} L` : `₹ ${formatNumberWithCommasinfo(currencyShotern(sum.value))}`}</span>
                                                                            <span className={`dark ms-2 ${index == summaryIndex ? 'selected' : ''}`}>{sum.name}</span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                            }
                                                        </div>
                                                    </Col>

                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col className="col-12">
                                        <h4>Financial Info</h4>
                                    </Col>
                                    {financialIncomeInfo.map((fInfo) => {
                                        return (
                                            <Col md="6" key={fInfo.id}>
                                                <Card>
                                                    <CardBody>
                                                        <div className="d-flex flex-column">
                                                            <h5>{fInfo.name}</h5>
                                                            {financialIncomeChartData &&
                                                                <ReactApexChart
                                                                    series={financialIncomeChartData[fInfo.id].series}
                                                                    options={financialIncomeChartData[fInfo.id].options}
                                                                    type={fInfo.chartType}
                                                                    height={320}
                                                                    className="apex-charts"
                                                                />
                                                            }
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Col>

                                        )
                                    })}
                                    <Col md={6} sm={12}>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex align-items-end">
                                                <h4>Shareholding Pattern</h4><h6 className="text-muted ms-2">{!isEmpty(shareHoldingPattersChartDate) ? `as of ${shareHoldingPattersChartDate}` : ''}</h6>
                                            </div>
                                            <Card>
                                                <CardBody>
                                                    {!isEmpty(shareHoldingProfiles) ?
                                                        <ReactApexChart
                                                            series={shareholdingChartData.series}
                                                            options={shareholdingChartData.options}
                                                            type='pie'
                                                            height={320}
                                                            className="apex-charts"
                                                        />
                                                        : <NoDataChart title='No Information Found' subtitle="We couldn't find the Shareholding Pattern for the client" />}
                                                </CardBody>
                                            </Card>
                                        </div>

                                    </Col>
                                    <Col md={6} sm={12}>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex align-items-end">
                                                <h4>Borrowing Profile</h4><h6 className="text-muted ms-2">{!isEmpty(borrowingProfileChartDate) ? `as of ${borrowingProfileChartDate}` : ''}</h6>
                                            </div>
                                            <Card>
                                                <CardBody>
                                                    {!isEmpty(borrowingProfilesData) ?
                                                        <ReactApexChart
                                                            series={borrowingChartData.series}
                                                            options={borrowingChartData.options}
                                                            type='pie'
                                                            height={320}
                                                            className="apex-charts"
                                                        />
                                                        : <NoDataChart title='No Information Found' subtitle="We couldn't find the Borrowing Profile for the client" />}
                                                </CardBody>
                                            </Card>
                                        </div>

                                    </Col>
                                    <Col className="col-12">
                                        <h4>Promoters and Directors</h4>
                                        <Card>
                                            <CardBody>
                                                <div className="row auth-person">
                                                    {!isEmpty(authPersons) ? authPersons.map((auth) => {
                                                        return <div className="col-3 mb-3" key={auth.name}><div className="d-flex flex-column">
                                                            <span className="name">{auth.name}</span>
                                                            <span className="other">{auth.designation}</span>
                                                            {auth.doj && (<span className="other">{auth.doj} (Date of Appointment)</span>)}
                                                        </div>
                                                        </div>

                                                    }) : <NoDataChart title='No Information Found' subtitle="We couldn't find the Promoters and Directors for the client" />}


                                                </div>
                                            </CardBody>
                                        </Card>
                                        {entityName ? <ShowMoreComponent handleMoreInfo={handleMoreInfo} entityData={entityInformation} /> : null}
                                        
                                    </Col>
                                </Row>
                            </div>
                        }
                    </div>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </React.Fragment>
    )
}

export default EntityInformation;
